<template>
    <v-btn                 
        :to="to"
        :color="color"
        @click="click"                
        depressed
        :block="block"
        :disabled="disabled"
        :loading="loading"
        :id="id"
        :alvqa="alvqa"
    >
        <v-icon 
            left 
            :class="{'mr-0': !getBtnLabel}"
            color="white" 
            v-if="icon !== ''"            
        >
            {{ icon }}
        </v-icon>
        <span class="white--text" :alvqa="alvqa + '-text'">{{ getBtnLabel }}</span>
    </v-btn>
</template>

<script>
import VBtn from 'vuetify/es5/components/VBtn'

export default {
    name: "BaseButton",
    extends: VBtn,
    props: {
        label: String,
        icon: {
            type: String,
            default: ''    
        },
        color: {
            default: "buttonStandard",
            type: String
        }, 
        id: String,
        alvqa: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        progressPercentage:{
            type: String,
            default:''
        },
        abbreviation: {
        type: String,
        default: ''
        }
    },
    computed:{
        royaltyControllingInProcess:{
            get(){return this.$store.getters.getPublishingStatementsRoyaltyControllingInProcess},
            set(value) { this.$store.commit('setPublishingStatementsRoyaltyControllingInProcess', value) }
        },
        getBtnLabel(){
            return this.progressPercentage === '' || 
                   this.progressPercentage === null || 
                   !this.royaltyControllingInProcess ? this.$t(this.label) : this.$t(this.label) + ': ' + this.progressPercentage + '%'
        }
    },
    methods: {
    // Function to convert a string to title case
    toTitleCase(str) {
        return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },

    click(event) {
        // Split the label into parts
        const labelParts = this.label.split('_');
        let buttonText;

        // Check if the label contains 'CAPTION' or 'BUTTON'
        const captionIndex = labelParts.indexOf('CAPTION');
        const buttonIndex = labelParts.indexOf('BUTTON');

        if (captionIndex !== -1) {
            // Extract everything after 'CAPTION' and convert to title case
            buttonText = this.toTitleCase(labelParts.slice(captionIndex + 1).join(' '));
        } else if (buttonIndex !== -1) {
            // Extract everything after 'BUTTON' and convert to title case
            buttonText = this.toTitleCase(labelParts.slice(buttonIndex + 1).join(' '));
        } else {
            // Default to last two words in title case
            buttonText = this.toTitleCase(labelParts.slice(-2).join(' '));
        }
        
        const eventName = `Clicked ${buttonText}`;
         let eventData = {
        'label': buttonText,
        'routePath': this.$route.path,
        'context': this.$route ? this.$route.name : 'unknown',
        // ... any other properties 
        };

        // Conditionally adding the abbreviation for specific routes
        if (['Income', 'SalesData', 'MappingsEdit'].includes(this.$route.name) && this.abbreviation) {
        eventData.abbreviation = this.abbreviation;
        }

        // Track the click with Mixpanel, including the abbreviation if condition is met
        mixpanel.track(eventName, eventData);


        // Emit the click event for parent components
        this.$emit('click', event);
    }
}
}

</script>